// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"5eb415ec","918":"3a9c3e0f"}[chunkId] + ".chunk.js";
};